import { useFieldArray, useFormContext } from 'react-hook-form';

import { BoxIcon } from '#atoms';
import Title from 'src/refactor_components/common/Title';
import { useLayoutEffect } from 'react';

export const CurriculumList = () => {
  const { control, register } = useFormContext<{
    curriculums: Array<{
      order: number;
      description: string;
    }>;
  }>();

  const { fields, append, remove, update } = useFieldArray({
    control,
    name: 'curriculums'
  });

  useLayoutEffect(() => {
    fields.map((value, targetIndex) => {
      update(targetIndex, {
        ...value,
        order: targetIndex + 1
      });
    });
  }, [fields.length]);

  return (
    <>
      <div className="flex flex-col gap-16 items-start">
        <Title text="커리큘럼" />
        {fields.map((value, index) => {
          return (
            <div key={value.id} className="w-full flex flex-col gap-5">
              <p className="text-[14px] text-[#EAE8ED]">{index + 1}주차</p>
              <div className="flex gap-8 items-center">
                <input
                  {...register(`curriculums.${index}.description`)}
                  className="focus:bg-white focus:text-black w-full bg-transparent p-10 text-16 rounded-[5px] h-44 placeholder:text-[#999] border border-solid border-[var(--color-gray-second)]"
                  placeholder="수업 내용 입력"
                />
                <button
                  type="button"
                  onClick={() => remove(index)}
                  className="cursor-pointer"
                >
                  <BoxIcon type="wastebasket" onlyIcon size={18} />
                </button>
              </div>
            </div>
          );
        })}
        <button
          type="button"
          className="text-[#9170F2] self-end"
          onClick={() => append({ order: fields.length + 1, description: '' })}
        >
          + 주차 추가
        </button>
      </div>
    </>
  );
};
